<div
  class="date-picker-header"
  [attr.data-size]="size"
  [attr.data-variant]="variant"
  [attr.data-layout]="layout"
  [attr.data-editable]="editable"
  [attr.data-disabled]="disabled"
  role="toolbar"
  [attr.aria-label]="'Calendar navigation for ' + displayText"
>
  <!-- Previous Month Button -->
  <umss-icon-button
    *ngIf="showNavigationArrows"
    iconName="phosphorCaretLeft"
    [size]="size"
    [variant]="editable ? 'Ghost' : 'Outline'"
    ariaLabel="Previous month"
    [disabled]="disabled || !canNavigatePrevious"
    (onClick)="onPreviousMonth()"
  >
  </umss-icon-button>

  <!-- Month/Year Display -->
  <div class="date-picker-header-content">
    <!-- YearAndMonth Layout - Separate Dropdowns -->
    <div *ngIf="layout === 'YearAndMonth'" class="date-picker-header-selectors">
      <!-- Editable Month Selector -->
      <umss-select
        *ngIf="editable"
        [options]="monthOptions"
        [value]="currentMonth"
        variant="Default"
        size="Small"
        [disabled]="disabled"
        placeholder="Select month"
        (selectionChange)="onMonthSelect($event)"
      >
      </umss-select>

      <!-- Non-editable Month Display -->
      <span *ngIf="!editable" class="date-picker-header-display">
        {{ currentMonthShort }}
      </span>

      <!-- Editable Year Selector -->
      <umss-select
        *ngIf="editable"
        [options]="yearOptions"
        [value]="currentYear"
        variant="Default"
        size="Small"
        [disabled]="disabled"
        placeholder="Select year"
        (selectionChange)="onYearSelect($event)"
      >
      </umss-select>

      <!-- Non-editable Year Display -->
      <span *ngIf="!editable" class="date-picker-header-display">
        {{ currentYear }}
      </span>
    </div>

    <!-- OnlyMonth Layout -->
    <div *ngIf="layout === 'OnlyMonth'">
      <!-- Editable Month Selector -->
      <umss-select
        *ngIf="editable"
        [options]="monthOptions"
        [value]="currentMonth"
        variant="Default"
        size="Small"
        [disabled]="disabled"
        placeholder="Select month"
        (selectionChange)="onMonthSelect($event)"
      >
      </umss-select>

      <!-- Non-editable Month Display -->
      <span *ngIf="!editable" class="date-picker-header-display">
        {{ currentMonthName }}
      </span>
    </div>

    <!-- OnlyYear Layout -->
    <div *ngIf="layout === 'OnlyYear'">
      <!-- Editable Year Selector -->
      <umss-select
        *ngIf="editable"
        [options]="yearOptions"
        [value]="currentYear"
        variant="Default"
        size="Small"
        [disabled]="disabled"
        placeholder="Select year"
        (selectionChange)="onYearSelect($event)"
      >
      </umss-select>

      <!-- Non-editable Year Display -->
      <span *ngIf="!editable" class="date-picker-header-display">
        {{ currentYear }}
      </span>
    </div>

    <!-- Standard Layouts (1Month, 2Months, 3Months) -->
    <ng-container
      *ngIf="
        layout === '1Month' || layout === '2Months' || layout === '3Months'
      "
    >
      <!-- Default Variant - Clickable Title -->
      <button
        *ngIf="variant === 'Default'"
        type="button"
        class="date-picker-header-title"
        [class.editable]="editable"
        [class.multi-month]="isMultiMonth"
        [disabled]="disabled"
        [attr.aria-label]="'Change month and year, currently ' + displayText"
        (click)="onMonthYearClick()"
      >
        {{ displayText }}
        <span
          *ngIf="editable"
          class="dropdown-indicator"
          [innerHTML]="dropdownIndicatorSvg"
        ></span>
      </button>

      <!-- Compact Variant - Simple Display -->
      <div
        *ngIf="variant === 'Compact'"
        class="date-picker-header-display"
        [class.multi-month]="isMultiMonth"
        [attr.aria-label]="displayText"
      >
        {{ displayText }}
      </div>
    </ng-container>
  </div>

  <!-- Next Month Button -->
  <umss-icon-button
    *ngIf="showNavigationArrows"
    iconName="phosphorCaretRight"
    [size]="size"
    [variant]="editable ? 'Ghost' : 'Outline'"
    ariaLabel="Next month"
    [disabled]="disabled || !canNavigateNext"
    (onClick)="onNextMonth()"
  >
  </umss-icon-button>
</div>
